import { render, staticRenderFns } from "./TheSvgList.vue?vue&type=template&id=376b1b73"
import script from "./TheSvgList.vue?vue&type=script&lang=js"
export * from "./TheSvgList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports